import React, { Component } from "react";
import { Form, Image } from "react-bootstrap";
import TooltipComponent from "../../component/TooltipComponent";
import { get } from "lodash";
import { isValidArray, GROUP_KEYS } from "../../helper";
import { KML_FORMATS, FILE_SIZE_LIMIT } from "../../constant";
import Files from "react-files";
import IconAttachment from "../../assets/attachment-icon-blue.svg";

const fields = {
  "170": [
    "project_cost_share",
    "geo_coordinates",
    "geo_coordinated_attachment",
    "population_benefitted"
  ],
  "150": ["geo_coordinates", "geo_coordinated_attachment"]
};
const fieldsStatePMG = ["geo_coordinates", "geo_coordinated_attachment"];
export class CreateProjectExtension extends Component {
  renderStateSpecificFields = fieldName => {
    const {
      centralCostTooltip,
      stateCostTooltip,
      centralCost,
      stateCost,
      onChange,
      onBlur,
      centralCostErr,
      error,
      geoCoordinates,
      populationBenefitted,
      onFilesChange,
      onFilesError,
      createFileTemplate,
      projectExtensionFiles = [],
      groupId,
      geoCordinateError,
      projectExtensionFilesErr,
      isUPproject
    } = this.props;
    switch (fieldName) {
      case "project_cost_share":
        return (
          <Form.Group className="field-cost">
            <Form.Label
              className="project-cost-title"
              data-test="label-project-cost"
            >
              Project Cost Share (in crores)
              <span className="required">*</span>
            </Form.Label>
            <div className="form-field">
              <div className="popup-wrapper cost">
                <Form.Label data-test="label-original-cost">
                  Central Share
                  <span className="required">*</span>
                </Form.Label>
                <span className="symbol-field-left">
                  <Form.Control
                    type="text"
                    value={centralCost}
                    onChange={e => onChange(e.target.value, "centralCost")}
                    onBlur={e => onBlur(e.target.value, "centralCost")}
                    isInvalid={get(centralCostErr, "error")}
                    min={0}
                  />
                  <span>Cr.</span>
                  <Form.Control.Feedback type="invalid">
                    {get(centralCostErr, "message")}
                  </Form.Control.Feedback>
                </span>
                <TooltipComponent
                  classes="create_project_tolltip"
                  content={centralCostTooltip}
                />
              </div>
              <div className="popup-wrapper revisedCost">
                <Form.Label data-test="label-revised-cost">
                  State Share
                  <span className="required">*</span>
                </Form.Label>
                <span className="symbol-field-left">
                  <Form.Control
                    data-test="revised-cost"
                    type="text"
                    value={stateCost}
                    isInvalid={get(error, "stateCost.error")}
                    onChange={e => onChange(e.target.value, "stateCost")}
                    onBlur={e => onBlur(e.target.value, "stateCost")}
                    min={0}
                  />
                  <span>Cr.</span>
                  <Form.Control.Feedback type="invalid">
                    {get(error, "stateCost.message")}
                  </Form.Control.Feedback>
                </span>
                <TooltipComponent
                  classes="create_project_tolltip"
                  content={stateCostTooltip}
                />
              </div>
            </div>
          </Form.Group>
        );
        break;

      case "geo_coordinates":
        return (
          <Form.Group className="geo-coordinates-field">
            <Form.Label data-test="label-project-name">
              <div>
                Geo Coordinates
                {groupId == 78 ? <span class="required">*</span> : null}
              </div>
              <p class="field-note">Attach KML/KMZ file wherever applicable</p>
            </Form.Label>
            <div className="form-field">
              <Form.Control
                data-test="geo-coordinates"
                type="text"
                maxLength="185"
                placeholder="Enter Geo Coordinates"
                onChange={e => {
                  onChange(e.target.value, "geoCoordinates");
                }}
                onBlur={e => {
                  onBlur(e.target.value, "geoCoordinates");
                }}
                value={geoCoordinates}
                isInvalid={geoCordinateError == "This field is required."}
                disabled={isUPproject}
              />
              {geoCordinateError == "This field is required." ? (
                <div
                  className="mt-1 district-mandatory-text"
                  style={{ marginBottom: "0.5%" }}
                >
                  This field is required.
                </div>
              ) : null}
            </div>
          </Form.Group>
        );
        break;

      case "geo_coordinated_attachment":
        return (
          <>
            {isValidArray(projectExtensionFiles) &&
            projectExtensionFiles.length > 0 ? (
              <div className="d-flex flex-wrap geo-coordinates-file-upload uploaded-file-wrapper form-group justify-content-end">
                <label class="form-label" />
                <div className="d-flex flex-wrap project-map-file-wrapper uploaded-file-wrapper geo-coordinates-attachment-files">
                  {createFileTemplate()}
                </div>
              </div>
            ) : null}
            {projectExtensionFiles.length < 10 && (
              <Form.Group className="best-practice-field-file multiple-attache-file">
                <label class="form-label" />
                <Files
                  className="add-geo-coordinates-kml-files"
                  onChange={file => {
                    onFilesChange(file);
                  }}
                  onError={file => {
                    onFilesError(file);
                  }}
                  multiple={false}
                  accepts={KML_FORMATS}
                  maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                  minFileSize={0}
                  clickable
                  ref={elem => {
                    this.files = elem;
                  }}
                  data-test="add-files"
                >
                  <div className="d-flex" data-test="upload-project-map">
                    <Image src={IconAttachment} alt="Plus Icon" />
                    <div className="geo-coordinates-file-text ml-1">
                      &nbsp;Add KML/KMZ File
                    </div>
                  </div>
                </Files>
              </Form.Group>
            )}
          </>
        );
        break;

      case "population_benefitted":
        return (
          <Form.Group>
            <Form.Label data-test="label-project-name">
              Population Benefitted
            </Form.Label>
            <div className="form-field">
              <Form.Control
                type="text"
                // maxLength="185"
                placeholder="Enter Population Benefitted"
                onChange={e => {
                  onChange(e.target.value, "populationBenefitted");
                }}
                onBlur={e => {
                  onBlur(e.target.value, "populationBenefitted");
                }}
                value={populationBenefitted}
              />
            </div>
          </Form.Group>
        );
        break;
    }
  };

  render() {
    const { groupId, fieldName, projectCategoryId } = this.props;

    if (
      !Object.keys(fields).includes(groupId) &&
      projectCategoryId === GROUP_KEYS.STATE
    ) {
      if (fieldsStatePMG.includes(fieldName)) {
        return this.renderStateSpecificFields(fieldName);
      }
    }

    if (!fields[groupId]) {
      return null;
    }

    if (!fields[groupId].includes(fieldName)) {
      return null;
    }

    return this.renderStateSpecificFields(fieldName);
  }
}
